import { DataAttributeDefinitions } from 'scrivito'

import { pisaMessageDataClass } from './Pisa/pisaMessageDataClass'

const attributes: DataAttributeDefinitions = {}

export const Message = pisaMessageDataClass(attributes)
